import { defineMessages } from 'react-intl'

export default defineMessages({
  close: {
    id: 'component.Commons.Close.close',
    defaultMessage: 'Close',
  },
  back: {
    id: 'component.Commons.Close.back',
    defaultMessage: 'Back',
  },
})
